import { Component, OnInit } from '@angular/core';
import {ICellEditorAngularComp} from 'ag-grid-angular';
import { HttpService } from 'src/app/services/http.service';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-cell-editor-datasheet',
  templateUrl: './cell-editor-datasheet.component.html',
  styleUrls: ['./cell-editor-datasheet.component.scss']
})
export class CellEditorDatasheetComponent implements ICellEditorAngularComp, OnInit {
  private params: any;

  public files: any = [];
  constructor(
    private httpService: HttpService
  ) { }

  ngOnInit(): void {
  }

  agInit(params: any): void {
    this.params = params;
    this.files = this.params.value.map((item: any) => {
      return {...item};
    });
  }

  getValue(): any {
    return this.files.slice();
  }

  addFile(): void {
    this.files.push({
      name: '',
      url: ''
    });
  }

  deleteFile(index: number): void {
    this.files.splice(index, 1);
  }

  save(): void {
    this.files = this.files.filter((item: any) => item.url.length > 10);
    this.params.stopEditing();
    this.httpService.post(environment.API_PATH + '/product/stage/edit/stop', {}).subscribe((res: any) => {});
  }

  cancel(): void {
    this.files = this.params.data.datasheet_new.slice();
    this.httpService.post(environment.API_PATH + '/product/stage/edit/stop', {}).subscribe((res: any) => {});
    this.params.stopEditing();
  }
}
